import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

function GetParent(data) {
    data.forEach(r => {
        const parent = data.find(r2 => r.parentId === r2.id);
        if (parent) { r.parentName = parent.name; }
    });
    return data;
}

export const LessonSubjectService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.LESSON_SUBJECT}`, null, wait).then((data) => {
            //data.sort((a, b) => { return a.order - b.order });
            data.sort((a, b) => {
                if (a.parentId === null && b.parentId === null) {
                    return a.order - b.order;
                }
                else if (a.parentId === null) {
                    return -1;
                }
                else if (b.parentId === null) {
                    return 1;
                }
                else if (a.parentId === b.parentId) {
                    return a.order - b.order;
                }
                return a.parentId - b.parentId;
            });
            callback(data);
        });
    },
    /*List(lessonId, callback, wait) {
        Ajax.Api(MethodType.Get, `${Enums.SERVICE.LESSON_SUBJECT}/filter/${lessonId}`, null, wait).then((data) => {
            callback(data);
        });
    },*/
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_SUBJECT + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
};